var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{directives:[{name:"tippy",rawName:"v-tippy",value:(_vm.tippyConfig),expression:"tippyConfig"}],staticClass:"svg-icon",class:[_vm.iconWrapClasses, _vm.themeClass],attrs:{"data-cy":_vm.dataCy},on:{"click":_vm.onClick,"focus":_vm.onFocus,"blur":_vm.onBlur}},[_c('inline-svg',{class:_vm.iconClasses,attrs:{"src":_vm.iconPath}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }